/* ============================================================
   KP Elite — Cart Drawer JS
   File: assets/kp-cart-drawer.js
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {

  /* ── Stack Add to Cart ───────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.kp-stack__add-btn');
    if (!btn) return;

    var variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;
    if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;

    btn.classList.add('is-loading');
    btn.textContent = 'Adding…';

    var cartDrawer = document.querySelector('cart-drawer');

    /* Build sections request the same way Dawn does */
    var sectionsToRender = [];
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sectionsToRender = cartDrawer.getSectionsToRender();
    }
    var sectionIds = sectionsToRender.map(function (s) { return s.id; });

    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (sectionIds.length) {
      body.sections = sectionIds;
      body.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart add failed: ' + r.status);
        return r.json();
      })
      .then(function (data) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = '✓ Added';

        /* Let Dawn handle its own re-render */
        if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
          cartDrawer.renderContents(data);
          /* Re-bind overlay click handler — renderContents replaces innerHTML
             which destroys the event listener bound in CartDrawer constructor */
          setTimeout(function () {
            var overlay = document.getElementById('CartDrawer-Overlay');
            if (overlay) {
              overlay.addEventListener('click', function () {
                cartDrawer.close();
              });
            }
          }, 100);
        }
      })
      .catch(function (err) {
        console.warn('KP stack add failed:', err);
        btn.classList.remove('is-loading');
        btn.textContent = 'Add to Cart →';
      });
  });

  /* ── Coupon banner sync ──────────────────────────────────── */
  function syncCoupon() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var couponBanner = document.getElementById('kp-coupon-banner');
        var couponPill   = document.getElementById('kp-coupon-pill');
        var couponRow    = document.getElementById('kp-coupon-row');
        var couponLabel  = document.getElementById('kp-coupon-label');
        var couponSav    = document.getElementById('kp-coupon-savings');
        var apps = cart.cart_level_discount_applications || [];
        if (apps.length > 0) {
          var code = apps[0].title;
          var amt  = '$' + (apps[0].total_allocated_amount / 100).toFixed(2);
          if (couponBanner) couponBanner.removeAttribute('hidden');
          if (couponPill)   couponPill.textContent = code;
          if (couponRow)    couponRow.classList.remove('kp-d-none');
          if (couponLabel)  couponLabel.textContent = code;
          if (couponSav)    couponSav.textContent   = '−' + amt;
        } else {
          if (couponBanner) couponBanner.setAttribute('hidden', '');
          if (couponRow)    couponRow.classList.add('kp-d-none');
        }
      }).catch(function () {});
  }

  /* ── Watch for Dawn re-renders to sync coupon ────────────── */
  var cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(syncCoupon, 200);
    }).observe(cartDrawer, { childList: true, subtree: true });
  }

  syncCoupon();
});
